<div class="relative">
  <button type="button" (click)="toggleDropdown()"
    class="flex h-9 sm:h-10 items-center justify-center gap-1.5 sm:gap-2 rounded-xl border border-border bg-surface px-2 sm:px-3 text-xs sm:text-sm font-semibold text-main shadow-2xs hover:bg-surface-hover active:bg-surface-hover/80 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all cursor-pointer shrink-0"
    aria-haspopup="listbox" aria-expanded="true" [attr.aria-activedescendant]="activeMenuLanguage()?.id">
    @if (activeMenuLanguage(); as lang) { @if (lang.Flag) {
    <img [src]="lang.Flag" [alt]="lang.Code" class="h-4 w-4 sm:h-5 sm:w-5 rounded-xs object-cover shrink-0 shadow-2xs" />
    }
    <span class="font-bold tracking-tight">{{ lang.Code | uppercase }}</span>
    } @else {
    <span class="font-semibold">...</span>
    }
    <svg class="-mr-0.5 h-3.5 w-3.5 sm:h-4 sm:w-4 text-muted shrink-0" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.29a.75.75 0 01.02-1.06z"
        clip-rule="evenodd" />
    </svg>
  </button>

  @if (isOpen()) {
  <div
    class="absolute right-0 z-50 mt-2 w-48 sm:w-56 origin-top-right rounded-xl border border-border bg-surface shadow-xl focus:outline-none overflow-hidden animate-in fade-in-50 zoom-in-95 duration-100"
    role="listbox" aria-orientation="vertical">
    <div class="py-1" role="none">
      @for (lang of availableLanguages(); track lang.id) {
      <button type="button"
        class="flex w-full items-center gap-2.5 px-3.5 py-2 text-left text-xs sm:text-sm font-medium text-main hover:bg-surface-hover active:bg-border/20 transition-colors cursor-pointer"
        role="option" [attr.aria-selected]="lang.id === activeMenuLanguage()?.id" (click)="selectLanguage(lang.id)">
        @if (lang.Flag) {
        <img [src]="lang.Flag" [alt]="lang.Code" class="h-4.5 w-4.5 shrink-0 rounded-xs object-cover shadow-2xs" />
        } @else {
        <div class="h-4.5 w-4.5 shrink-0 rounded-xs bg-border"></div>
        }
        <span class="truncate font-semibold">
          {{ lang.Native || lang.Name || (lang.Code | uppercase) }}
        </span>
      </button>
      }
    </div>
  </div>
  }
</div>